import SubscriptionStatsList from './SubscriptionStatsList';

export default {
    list: SubscriptionStatsList,
};
